<template>
    <div class="container">
        <b-modal
            :model-value="showDialogCrearNiif"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-niif-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="niif"
                            type="number"
                            class="form-input"
                            :placeholder="labels.niifPlaceholder"
                            @input="onChange"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.description }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="descripcion"
                            type="text"
                            class="form-input"
                            :placeholder="labels.descriptionPlaceholder"
                            @input="onChange"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.levelFirst }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="firstLevSel"
                            class="form-input"
                            @change="onChange"
                        >
                            <b-form-select-option :value="null">
                                -- {{ labels.select }} --
                            </b-form-select-option>
                            <b-form-select-option 
                                v-for="firstLev in listFirstLevel" 
                                :key="firstLev.id" 
                                :value="String(firstLev.primer_nivel)"
                            >
                                {{ firstLev?.descripcion }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.levelSecond }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="secondLevSel"
                            class="form-input"
                            @change="onChange"
                        >
                            <b-form-select-option :value="null">
                                -- {{ labels.select }} --
                            </b-form-select-option>
                            <b-form-select-option 
                                v-for="secondLev in listSecondLevel" 
                                :key="secondLev.id" 
                                :value="String(secondLev.segundo_nivel)"
                            >
                                {{ secondLev?.descripcion }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeDialog">
                        {{ labels.close }}
                    </b-button>
                    <b-button 
                        class="reset-btn-primary ml-2" 
                        @click="confirmSave"
                        :disabled="!hasUnsavedChanges || isLoading || !niif || !descripcion || !firstLevSel || !secondLevSel"
                    >
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <b-modal
            :model-value="showConfirmModal"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="md"
            :title="confirmLabels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog confirm-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ confirmLabels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ confirmLabels.infoText }}</div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeConfirmModal">
                        {{ confirmLabels.cancel }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="executeAction">
                        {{ confirmLabels.confirm }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PlanConsolidacion from '../../services/PlanConsolidacion' 
import SegundoNivel from '../../services/SegundoNivel'

export default {
    name: "Crear",
    props: {
        showDialogCrearNiif: {
            type: Boolean,
            default: false
        },
        vigencia: {
            type: String,
            default: ""
        },
        codReporte: {
            type: String,
            default: ""
        },
        listFirstLevel: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        niif: "",
        descripcion: "",
        firstLevSel: null,
        secondLevSel: null,
        listSecondLevel: [],
        hasUnsavedChanges: false,
        isLoading: false,
        isLoadingSecondLevel: false,
        showConfirmModal: false,
        pendingAction: null,
        originalData: {
            niif: "",
            descripcion: "",
            firstLevSel: null,
            secondLevSel: null
        }
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear NIIF",
                    infoTitle: "Nuevo NIIF",
                    infoText: "Ingresa los datos del nuevo NIIF y guarda los cambios.",
                    niif: "NIIF",
                    niifPlaceholder: "Ingrese el código NIIF",
                    description: "Descripción",
                    descriptionPlaceholder: "Ingrese la descripción del NIIF",
                    select: "Seleccione...",
                    levelFirst: "Primer Nivel",
                    levelSecond: "Segundo Nivel",
                    save: "Guardar",
                    close: "Cerrar"
                }
            } else {
                return {
                    title: "Create NIIF",
                    infoTitle: "New NIIF",
                    infoText: "Enter the new NIIF data and save the changes.",
                    niif: "NIIF",
                    niifPlaceholder: "Enter NIIF code",
                    description: "Description",
                    descriptionPlaceholder: "Enter NIIF description",
                    select: "Select...",
                    levelFirst: "First Level",
                    levelSecond: "Second Level",
                    save: "Save",
                    close: "Close"
                }
            }
        },
        confirmLabels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Confirmar acción",
                    infoTitle: "¿Está seguro?",
                    infoText: this.pendingAction === 'save' 
                        ? "¿Está seguro que desea crear este NIIF?" 
                        : "¿Está seguro que desea cerrar sin guardar los cambios?",
                    confirm: "Confirmar",
                    cancel: "Cancelar"
                }
            } else {
                return {
                    title: "Confirm action",
                    infoTitle: "Are you sure?",
                    infoText: this.pendingAction === 'save' 
                        ? "Are you sure you want to create this NIIF?" 
                        : "Are you sure you want to close without saving?",
                    confirm: "Confirm",
                    cancel: "Cancel"
                }
            }
        }
    },
    watch: {
        niif() { 
            this.hasUnsavedChanges = this.checkChanges() 
        },
        descripcion() { 
            this.hasUnsavedChanges = this.checkChanges() 
        },
        secondLevSel() { 
            this.hasUnsavedChanges = this.checkChanges() 
        },
        showDialogCrearNiif: {
            handler(newVal) {
                if (newVal) {
                    this.isLoading = false
                    this.isLoadingSecondLevel = false
                    this.hasUnsavedChanges = false
                    this.listSecondLevel = []
                    this.secondLevSel = null
                    this.firstLevSel = null
                    this.niif = ""
                    this.descripcion = ""
                    this.pendingAction = null
                    this.saveOriginalData()
                }
            },
            immediate: true
        },
        firstLevSel: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && this.showDialogCrearNiif) {
                    this.secondLevSel = null
                    this.hasUnsavedChanges = this.checkChanges()
                    this.loadSecondLevel()
                }
            }
        }
    },
    methods: {
        saveOriginalData() {
            this.originalData = {
                niif: "",
                descripcion: "",
                firstLevSel: null,
                secondLevSel: null
            }
        },
        checkChanges() {
            return this.niif !== this.originalData.niif ||
                   this.descripcion !== this.originalData.descripcion ||
                   this.firstLevSel !== this.originalData.firstLevSel ||
                   this.secondLevSel !== this.originalData.secondLevSel
        },
        onChange() {
            this.hasUnsavedChanges = this.checkChanges()
        },
        clearCampos() {
            this.niif = ""
            this.descripcion = ""
            this.firstLevSel = null
            this.secondLevSel = null
            this.listSecondLevel = []
            this.hasUnsavedChanges = false
            this.isLoadingSecondLevel = false
            this.pendingAction = null
        },
        closeDialog() {
            if (this.hasUnsavedChanges) {
                this.pendingAction = 'close'
                this.showConfirmModal = true
            } else {
                this.clicked()
            }
        },
        confirmSave() {
            if (this.niif == "") {
                this.$toast.error("El campo NIIF debe estar diligenciado")
                return
            }
            if (this.descripcion == "") {
                this.$toast.error("El campo Descripción debe estar diligenciado")
                return
            }
            if (!this.firstLevSel) {
                this.$toast.error("El campo primer nivel debe estar diligenciado")
                return
            }
            if (!this.secondLevSel) {
                this.$toast.error("El campo segundo nivel debe estar diligenciado")
                return
            }
            this.pendingAction = 'save'
            this.showConfirmModal = true
        },
        closeConfirmModal() {
            this.showConfirmModal = false
            this.pendingAction = null
        },
        executeAction() {
            this.showConfirmModal = false
            const action = this.pendingAction
            this.pendingAction = null

            if (action === 'save') {
                this.creaNiif()
            } else if (action === 'close') {
                this.clicked()
            }
        },
        clicked() {
            this.$emit('clicked', false)
            this.clearCampos()
        },
        reload() {
            this.$emit('reload')
        },
        loadSecondLevel() {
            if (this.firstLevSel && this.codReporte) {
                this.isLoadingSecondLevel = true
                const primerNivelNumero = Number(this.firstLevSel)
                SegundoNivel.getAllLevelSecondByLevelFirstByReport(primerNivelNumero, this.codReporte)
                    .then((res) => {
                        this.listSecondLevel = res.data.secondLevByFirstLev || []
                    })
                    .catch((err) => {
                        console.error(err)
                        this.listSecondLevel = []
                        this.$toast.error("Error al cargar los niveles secundarios")
                    })
                    .finally(() => {
                        this.isLoadingSecondLevel = false
                    })
            } else {
                this.listSecondLevel = []
            }
        },
        creaNiif() {
            this.isLoading = true
            let form = {
                'niif': this.niif,
                'descripcion': this.descripcion,
                'primerNivel': Number(this.firstLevSel),
                'segundoNivel': Number(this.secondLevSel),
                'vigencia': this.vigencia,
                'codReporte': this.codReporte,
                'idUser': this.$store.state.userId
            }

            PlanConsolidacion.createPlanconsolidacion(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.clicked()
                    this.reload()
                })
                .catch((err) => {
                    if (err.response?.status == 412) {
                        this.$toast.error(err.response.data.message)
                    } else {
                        this.$toast.error("Error al crear el NIIF")
                    }
                    console.error(err)
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>

<style src="../main.css"></style>